<template>
  <div class="full-height md-flex lg-flex items-center">
    <div
      v-if="showAllLaguages"
      class="full-height top-0 left-0 col-12 absolute modal outside"
      style="z-index: 4"
      @click="toggleLanguages(false)"
    ></div>
    <div class="flex flex-wrap col-12 relative grey-bg p3 justify-center">
      <div class="col-12">
        <div class="col-12 flex justify-center">
          <UserPhoto style="width: 125px; height: 125px; min-width: 125px; min-height: 125px;" />
        </div>
        <div class="col-12 py2">
          <div class="flex justify-center h1n semi-bold caps py1">{{ getReferencelabel("HELLO") }}</div>
          <div class="flex justify-center blue h3n bold">{{ user.firstname }} {{ user.lastname }}</div>
        </div>
        <hr class="horizontal-divisor pt2 ">
        <!-- <div class="relative flex justify-center pb3 pointer z5" @click="toggleLanguages(!showAllLaguages)">
          <div class="flex justify-center table absolute white-bg py1 rounded ">
            <div class="col-12 table-cell align-bottom flex items-center flex-wrap ml2 pointer" style="width:52px;">
              <div class="flex" :class="{'language-border-display':showAllLaguages}">
                <component :is="selectedLanguage" />
                <span class="bold pl1 flex items-center"> {{ selectedLanguage.toUpperCase() }}</span>
              </div>

              <div v-if="showAllLaguages" class="pt2">
                <div v-for="(locale, position) of allowedLanguagues" :key="position" @click="changeLocale(locale)">
                  <div v-if="selectedLanguage !== locale" class="flex pb1 pointer">
                    <component :is="locale" />
                    <span class="bold pl1 "> {{ locale.toUpperCase() }} </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-cell align-top pl2 px2">
              <i v-if="!showAllLaguages" class="icon-angle-down-icon pointer bold"> </i>
              <i v-else class="icon-angle-up-icon pointer bold"> </i>
            </div>
          </div>
        </div> -->
      </div>

      <div v-for="content of homepageDisplay" v-if="homepageDisplay && homepageDisplay.length" class="col-12 md-col-9">
        <div v-if="!content.display_content_type" v-html="getConfigurationContent(content)"> </div>
        <DisplayContent v-else :content="content" />
      </div>

      <!-- <div class="home-content">
        <h1 class="center my0 blue">Bienvenue à l'UCPA</h1>
        <div class="home-notifications-block">
          <UpcomingVacances></UpcomingVacances>
          <UpcomingLoisirs></UpcomingLoisirs>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// import UpcomingVacances from '@/components/home/UpcomingVacances';
// import UpcomingLoisirs from '@/components/home/UpcomingLoisirs';

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import UserPhoto from '@/components/elements/UserPhoto';
import DisplayContent from '@/components/elements/DisplayContent.vue';
import { getConfigurationContent, getReferencelabel } from '@/mixins/utils';

import fr from '@/components/flags/frFlag.vue';
import en from '@/components/flags/enFlag.vue';

export default {
  components: {
    fr,
    en,
    // UpcomingLoisirs,
    // UpcomingVacances
    UserPhoto,
    DisplayContent
  },
  setup () {
    const store = useStore();
    const user = computed(() => store.state.user);
    const router = useRouter();
    const showAllLaguages = ref(false);

    function toggleLanguages (value) {
      showAllLaguages.value = value;
    }

    const allowedLanguagues = computed(() => store.state.allowedLanguages);
    const selectedLanguage = computed(() => store.getters.getLanguage);
    const homepageDisplay = computed(() => store.getters.getSiteConfiguration('display_content', 'HOME_PAGE_SECTION'));

    function changeLocale (locale) {
      store.commit('setSelectedLanguage', locale);
      router.push({ name: 'Home', params: { locale: locale === 'fr' ? '' : locale } });
    }

    return { user, toggleLanguages, showAllLaguages, selectedLanguage, changeLocale, allowedLanguagues, homepageDisplay, getConfigurationContent, getReferencelabel };
  }
};
</script>

<style lang="scss">
.transition {
  	transition: height 350ms ease-in-out, opacity 750ms ease-in-out;
}
.home-notifications-block {
  padding: 0.4rem 0rem;
}

.language-border-display{
  border-bottom: 1px solid #00a6c6;
}

.horizontal-divisor {
  width: 150px;
  height: 0px;
  border-top: 3px solid white;
  border-left: 0px;
  border-right: 0px;
  border-bottom: 0px;
}
</style>
